<app-navbar>
  <app-user-action></app-user-action>
</app-navbar>
<div class="page-layout">
  <app-sidebar></app-sidebar>
  <div class="main-content">
    @if (mainItem) {
      <div class="ui container item-container">
        <header class="item-title">
          <div class="name_cn">{{mainItem.nameCn}}</div>
          <div class="name">{{mainItem.name}}</div>
        </header>
        <div class="item-info-wrapper">
          @if (!mainItem.coverImage) {
            <div class="item-img-placeholder"></div>
          }
          @if (mainItem.coverImage) {
            <div class="item-img">
              @if (mainItem.coverImage) {
                <ui-responsive-image [src]="mainItem.coverImage.url"
                           [size]="{
                                    width: '100%',
                                    ratio: mainItem.coverImage.height / mainItem.coverImage.width,
                                    originalWidth: mainItem.coverImage.width,
                                    originalHeight: mainItem.coverImage.height}"
                [background]="mainItem.coverImage.dormantColor"></ui-responsive-image>
              }
            </div>
          }
          <div class="item-content-wrapper">
            <div class="ui secondary pointing menu">
              <a class="item" [ngClass]="{active: selectedTab === 'overview'}" (click)="changeTab('overview')">简介</a>
              @if (mainItem.subItems && isEpisodesEnabled) {
                <a class="item"  [ngClass]="{active: selectedTab === 'episodes'}" (click)="changeTab('episodes')" >剧集列表</a>
              }
              @if (isStaffEnabled) {
                <a class="item" [ngClass]="{active: selectedTab === 'staff'}" (click)="changeTab('staff')">制作人员</a>
              }
              @if (isRelatedItemsEnabled) {
                <a class="item" [ngClass]="{active: selectedTab === 'related'}" (click)="changeTab('related')">相关条目</a>
              }
              @if (isPersonItemsEnabled) {
                <a class="item" [ngClass]="{active: selectedTab === 'personItems'}" (click)="changeTab('personItems')">参与作品</a>
              }
              <a class="item" [href]="bgmURL" target="_blank"><i class="external alternate icon"></i>bgm.tv</a>
              @if (isAdminUser) {
                <a class="item" [href]="adminUrl"><i class="edit icon"></i>Edit</a>
              }
            </div>
            @if (selectedTab === 'overview') {
              <app-overview
                [mainItem]="mainItem"
                [user]="user"
                [favorite]="favorite"
                [relatedMainItems]="relatedMainItems"
                [itemRelations]="itemRelations"
                [itemPersonRelations]="itemPersonRelations"
              [itemCastCharacterRelations]="itemCastCharacterRelations"></app-overview>
            }
            @if (selectedTab === 'episodes' && mainItem.subItems && isEpisodesEnabled) {
              <app-episode-list [subItems]="mainItem.subItems" [itemId]="mainItem.id"></app-episode-list>
            }
            @if (selectedTab === 'staff' && isStaffEnabled) {
              <app-staff-list [relatedMainItems]="relatedMainItems" [relations]="itemPersonRelations"></app-staff-list>
            }
            @if (selectedTab === 'related' && isRelatedItemsEnabled) {
              <app-item-list [relatedMainItems]="relatedMainItems" [relations]="itemRelations"></app-item-list>
            }
            @if (selectedTab === 'personItems' && isPersonItemsEnabled) {
              <app-person-item-list [relatedMainItems]="relatedMainItems" [relations]="itemPersonRelations"></app-person-item-list>
            }
          </div>
          <div class="item-basic-info">
            @for (prop of basicProperties; track prop) {
              <div class="info-item">
                <div class="info-key">{{prop.bgmKey}}</div>
                @if (prop.isArrayValue) {
                  <div class="info-values">
                    @for (propValue of $any(prop.value); track propValue) {
                      <div class="info-value">
                        @if (isString(propValue)) {
                          {{propValue}}
                        }
                        @if (!isString(propValue) && isKVPair(propValue)) {
                          <span class="value-key">{{propValue.k}}</span>
                          <span class="value-value">{{propValue.v}}</span>
                        }
                        @if (!isString(propValue) && !isKVPair(propValue)) {
                          @for (entry of propValue | keyvalue; track entry) {
                            <span class="value-key">{{entry.key}}</span>
                            <span class="value-value">{{entry.value}}</span>
                          }
                        }
                      </div>
                    }
                  </div>
                }
                @if (!prop.isArrayValue) {
                  <div class="info-value">{{prop.value}}</div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
</div>
